module.exports = __webpack_public_path__ + "img/layanan_biru.9aeabc9c.png";